import React, { forwardRef } from "react";
import styles from "./shared.module.scss";
import {
  ActionIcon,
  type ActionIconProps,
  Burger,
  type BurgerProps,
  Flex as MFlex,
  type FlexProps as MFlexProps,
} from "@mantine/core";

export const LogbookPageContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.logbookPageContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const PageContainer = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ children, className, ...rest }, ref) => (
  <div
    ref={ref}
    className={`${styles.pageContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
));
PageContainer.displayName = "PageContainer";

export const CardsContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.cardsContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Divider: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.divider} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const SmallDivider: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div
    className={`${styles.divider} ${styles.smallDivider} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const LayoutContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.layoutContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const ButtonsWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.buttonsWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const SectionDivider: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    mr?: string;
    mb?: number;
    error?: boolean;
  }
> = ({ children, mr, mb, error, className, style, ...rest }) => {
  const inline: React.CSSProperties = {
    ...(style ?? {}),
    ...(mb ? { marginBottom: `${mb}px` } : {}),
    ...(mr ? { marginRight: mr } : {}),
  };
  return (
    <div
      className={`${styles.sectionDivider} ${error ? styles.error : ""} ${className ?? ""}`}
      style={inline}
      {...rest}>
      {children}
    </div>
  );
};

interface FlexProps extends MFlexProps {
  flex?: number;
  center?: boolean;
}

export const Flex: React.FC<FlexProps> = ({
  flex,
  center,
  className,
  style,
  children,
  ...rest
}) => (
  <MFlex
    className={`${center ? styles.flexCenter : ""} ${className ?? ""}`}
    style={{ ...(style ?? {}), ...(flex ? { flex } : {}) }}
    {...(rest as any)}>
    {children}
  </MFlex>
);

export const StyledBurger = forwardRef<HTMLButtonElement, BurgerProps>(
  (props, ref) => <Burger color="main.6" ref={ref} {...props} />,
);
StyledBurger.displayName = "StyledBurger";

export const StyledActionIcon: React.FC<ActionIconProps> = props => (
  <ActionIcon className={styles.styledActionIcon} {...props} />
);
